import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Accordion,
  AccordionPanel,
  Spinner,
  Meter,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  Alert,
  Info,
  Link
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";

class StaticTypeDemoDisplay extends Component {
  constructor(props) {
    super(props);

    this._launchStaticPage = this._launchStaticPage.bind(this);
  }

  componentDidMount() {}

  _launchStaticPage(){
    window.open(this.props.StatUrl, "_blank");
  }

  render() {
    return (
      <Main flex="grow" fill="vertical" overflow="auto">
        <Layer animate modal={false}>
          <Box align="center" justify="center">
            <Box
              align="center"
              justify="center"
              background={{ color: "brand" }}
              fill="horizontal"
            >
              <Box
                align="center"
                justify="between"
                direction="row"
                gap="medium"
                fill="horizontal"
              >
                <Info size="large" color="yellow" />
                <Heading size="xsmall" level="1" margin="xsmall">
                  {this.props.DemoName}
                </Heading>
              </Box>
            </Box>
            <Box align="center" justify="center">
              <Heading size="xxsmall" level="4" margin="xxsmall">
                Please open url :{" "}
                <Button
                  label="Click Here"
                  primary
                  icon={<Link />}
                  onClick={
                    this._launchStaticPage
                  }
                /> <br />
                UserId : {this.props.StatUid}
                <br />
                Password : {this.props.StatPwd}
              </Heading>
            </Box>
            <Box
              align="center"
              justify="center"
              direction="row"
              gap="large"
              margin="medium"
            >
              <Button
                label="OK"
                active={false}
                primary
                reverse
                type="button"
                onClick={this.props.hide}
              />
            </Box>
          </Box>
        </Layer>
      </Main>
    );
  }
}

export default StaticTypeDemoDisplay;
